
import { getProductByID, toRollerShutter } from 'modules/shop-front/shop-front-component/ProductCollection'
import GenericProductPage from '../GenericProductPage'




export default function RS36mm() {

  return (
      GenericProductPage(getProductByID(62),toRollerShutter)
  )
}
